// extracted by mini-css-extract-plugin
module.exports = {"sandbox":"pci__sandbox___WzFhe","isReadOnly":"pci__isReadOnly___4c8qh","isCorrect":"pci__isCorrect___nAul8","isNotCorrect":"pci__isNotCorrect___E7ovQ"};